import _ from 'underscore';
import axiosInstance from '../config/axiosInstance';
import errorHandler from '../utils/errorHandler';

export const getServicePaginated = async ({ filters, continuationToken, order, rowsPerPage }) => {
  try {
    const headers = { 'x-page-size': rowsPerPage, 'x-is-paginated': true };

    if (filters && !_.isEmpty(filters)) {
      headers['x-filters'] = JSON.stringify(filters);
    }

    if (continuationToken) {
      headers['x-continuation-token'] = continuationToken;
    }

    if (order && order.by) {
      headers['x-order'] = `${order.by} ${order.type}`;
    }

    const { data } = await axiosInstance().get('/service', { headers });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getServiceById = async (id) => {
  try {
    const { data } = await axiosInstance().get(`/service/${id}`);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const createService = async (values) => {
  try {
    const { data } = await axiosInstance().post(`/service`, values, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const updateService = async (values, id) => {
  try {
    const { data } = await axiosInstance().put(`/service/${id}`, values, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const deleteService = async (id) => {
  try {
    const { data } = await axiosInstance().delete(`/service/${id}`);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};
